import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductListPageBody } from "../components/ProductListPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
export const Template = (
    props: templates.ProductListPageTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ProductListPageBody {...props} />
        </PageSkeleton>
    );
};
